import React from 'react';

// Icon wrapper component
const IconWrapper = ({ children, className = "", ...props }: React.SVGProps<SVGSVGElement>) => (
  <svg
    width="1em"
    height="1em"
    fill="currentColor"
    viewBox="0 0 24 24"
    className={className}
    {...props}
  >
    {children}
  </svg>
);

//GearIcon
export const DMSettingsIcon = (props: React.SVGProps<SVGSVGElement>) => (
  <IconWrapper {...props}>
    <path
      fill="currentColor"
      d="M14.25 4L14.6875 6.09375C15.0625 6.28125 15.4062 6.46875 15.75 6.71875L17.7812 6.0625L20.0312 9.96875L18.4688 11.4062C18.4688 11.5938 18.4688 11.8125 18.4688 12C18.4688 12.2188 18.4688 12.4062 18.4688 12.625L20.0312 14.0625L17.7812 17.9688L15.75 17.3125C15.4062 17.5312 15.0625 17.75 14.6875 17.9062L14.25 20H9.75L9.28125 17.9375C8.90625 17.75 8.5625 17.5625 8.21875 17.3125L6.1875 17.9688L3.9375 14.0625L5.5 12.625C5.5 12.4375 5.5 12.2188 5.5 12.0312C5.5 11.8125 5.5 11.5938 5.5 11.4062L3.9375 9.96875L6.1875 6.0625L8.21875 6.71875C8.5625 6.46875 8.90625 6.28125 9.28125 6.09375L9.75 4H14.25ZM16.2188 8.15625L15.5 8.375L14.875 7.9375C14.625 7.75 14.3438 7.59375 14.0625 7.46875L13.375 7.15625L13.2188 6.4375L13.0312 5.5H10.9375L10.75 6.4375L10.5938 7.15625L9.90625 7.46875C9.625 7.59375 9.34375 7.75 9.09375 7.9375L8.46875 8.375L7.78125 8.15625L6.875 7.875L5.84375 9.65625L6.53125 10.2812L7.0625 10.8125L7 11.5312C7 11.6875 7 11.8438 7 12C7 12.1875 7 12.3438 7 12.5L7.0625 13.2188L6.53125 13.7188L5.84375 14.375L6.875 16.1562L7.78125 15.875L8.46875 15.6562L9.09375 16.0938C9.34375 16.2812 9.625 16.4375 9.90625 16.5625L10.5938 16.875L10.75 17.5938L10.9375 18.5312H13.0312L13.2188 17.5938L13.375 16.875L14.0625 16.5625C14.3438 16.4375 14.625 16.2812 14.875 16.0938L15.5 15.6562L16.2188 15.875L17.0938 16.1562L18.125 14.375L17.4375 13.7188L16.9062 13.2188L16.9688 12.5C16.9688 12.3438 17 12.1875 17 12C17 11.8438 16.9688 11.6875 16.9688 11.5312L16.9062 10.8125L17.4375 10.2812L18.125 9.65625L17.0938 7.875L16.2188 8.15625ZM13.5 12C13.5 11.4688 13.1875 11 12.75 10.7188C12.2812 10.4375 11.6875 10.4375 11.25 10.7188C10.7812 11 10.5 11.4688 10.5 12C10.5 12.5625 10.7812 13.0312 11.25 13.3125C11.6875 13.5938 12.2812 13.5938 12.75 13.3125C13.1875 13.0312 13.5 12.5625 13.5 12ZM9 12C9 10.9375 9.5625 9.96875 10.5 9.40625C11.4062 8.875 12.5625 8.875 13.5 9.40625C14.4062 9.96875 15 10.9375 15 12C15 13.0938 14.4062 14.0625 13.5 14.625C12.5625 15.1562 11.4062 15.1562 10.5 14.625C9.5625 14.0625 9 13.0938 9 12Z"
    />
  </IconWrapper>
);

//IndustryWindowsSolidFilledIcon
export const DMSitesIcon = (props: React.SVGProps<SVGSVGElement>) => (
  <IconWrapper {...props}>
    <path
      fill="currentColor"
      d="M4 5H8V11L14 8V11L20 8V11V19H4V16V11V5ZM13.25 13.75H10.75V16.25H13.25V13.75ZM9.25 13.75H6.75V16.25H9.25V13.75ZM17.25 13.75H14.75V16.25H17.25V13.75Z"
    />
  </IconWrapper>
);

//ArrowRightFromBracketIcon
export const DMLogoutIcon = (props: React.SVGProps<SVGSVGElement>) => (
  <IconWrapper {...props}>
    <path
      fill="currentColor"
      d="M9.25 6.5H5.5V17.5H9.25H10V19H9.25H4.75H4V18.25V5.75V5H4.75H9.25H10V6.5H9.25ZM19.4062 12.5312L15.4062 16.5312L14.875 17.0625L13.8125 16L14.3438 15.4688L17.0625 12.75H9.75H9V11.25H9.75H17.0625L14.3438 8.53125L13.8125 8L14.875 6.9375L15.4062 7.46875L19.4062 11.4688L19.9375 12L19.4062 12.5312Z"
    />
  </IconWrapper>
);

//ChevronDownIcon (used for timestamp/datamind markers)
export const DMTimestampTriangleIcon = (props: React.SVGProps<SVGSVGElement>) => (
  <IconWrapper {...props}>
    <path
      fill="currentColor"
      d="M7.41 8.59L12 13.17l4.59-4.58L18 10l-6 6-6-6 1.41-1.41z"
    />
  </IconWrapper>
);

//BellIcon
export const DMNotificationsIcon = (props: React.SVGProps<SVGSVGElement>) => (
  <IconWrapper {...props}>
    <path
      fill="currentColor"
      d="M13 4V5.625C15.2812 6.0625 17 8.09375 17 10.5V13.25L19 15.5V17H17.5H6.5H5V15.5L7 13.25V10.5C7 8.09375 8.71875 6.0625 11 5.625V4H13ZM15.5 13.8438V13.25V10.5C15.5 8.59375 13.9062 7 12 7C10.0625 7 8.5 8.59375 8.5 10.5V13.25V13.8438L8.09375 14.25L7 15.5H16.9688L15.875 14.25L15.5 13.8438ZM14 18C14 18.5312 13.7812 19.0625 13.4062 19.4375C13.0312 19.8125 12.5312 20 12 20C11.4688 20 10.9375 19.8125 10.5625 19.4375C10.1875 19.0625 10 18.5312 10 18H12H14Z"
    />
  </IconWrapper>
);

//ErrorIcon
export const DMUngroupedIcon = (props: React.SVGProps<SVGSVGElement>) => (
  <IconWrapper {...props}>
    <path
      fill="currentColor"
      d="M12.5 5.5V9.5H11V5.5H12.5ZM12.5 14.5V16H11V14.5H12.5ZM14.5938 12L10.5938 4H11.75H12.7188L16.7188 12L20 18.5H17.3438H14.5938ZM15.2812 13.5L11.75 7.125L8.21875 13.5L6.65625 17H16.3125L15.2812 13.5Z"
    />
  </IconWrapper>
);

//ArrowUpShortWideIcon
export const DMMachinesIcon = (props: React.SVGProps<SVGSVGElement>) => (
  <IconWrapper {...props}>
    <path
      fill="currentColor"
      d="M10.2188 5.21875L10.75 5.75L10.2188 6.28125L6.21875 10.2812L5.15625 9.21875L7.875 6.5H2.75H2V5H2.75H7.875L5.15625 2.28125L6.21875 1.21875L10.2188 5.21875ZM22 14V15.5H21.25H10.75H10V14V15.5ZM22 17.75V19.25H21.25H16.75H16V17.75V19.25ZM22 10.25V11.75H21.25H7.75H7V10.25V11.75ZM22 6.5V8H21.25H13.75H13V6.5V8Z"
    />
  </IconWrapper>
);